import { render, staticRenderFns } from "./ReclamationInnerTableHead.vue?vue&type=template&id=674c5cf4&"
import script from "./ReclamationInnerTableHead.vue?vue&type=script&lang=js&"
export * from "./ReclamationInnerTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports